const categories = {
    all: 'Tous',
    MAN_TSHIRT: 'T-shirts Unisexe/Hommes',
    MAN_HOODIES: 'Sweats à capuche Hommes',
    MAN_SWEATSHIRT: 'Sweat-shirts Hommes',
    MAN_LONGLEEVES: 'Manches longues Hommes',
    MAN_TANKTOP: 'Débardeurs Hommes',
    TROUSERS_UNDERWEAR: 'Pantalons & Sous-vêtements',
    WOMAN_TSHIRT: 'T-shirts Femmes',
    WOMAN_TANKTOP: 'Débardeurs Femmes',
    WOMAN_SWEATSHIRT: 'Sweat-shirts Femmes',
    KINDER_TSHIRT: 'T-shirts Enfants',
    OTHER: 'Autres articles',
    MUG: 'Tasses & Verres',
    HOME: 'Maison & Décoration',
    MAN_TROUSERS_AND_SHORTS: 'Pantalons & Shorts Hommes',
    MAN_UNDERWEAR: 'Sous-vêtements Hommes',
    KIDS_TSHIRT: 'T-shirts Enfant',
    KIDS_HOODIE: 'Hoodies Enfant',
    KIDS_SWEATSHIRT: 'Sweatshirts Enfant',
    KIDS_OTHER: 'Autres Articles Enfant',
    POSTER_AND_CANVAS: 'Affiche & Toile',
    GLASS_DISPLAY: 'Présentoirs en verre',
    STUFFED_ANIMAL: 'Peluche',
    PILLOW: 'Coussins',
    DOOR_MAT: 'Paillassons',
    ORNAMENT: 'Ornements',
    HEADWEAR: 'Coiffes',
    BAG: 'Sacs',
    SOCKS: 'Chaussettes',
    PHONE_CASE: 'Coque de Téléphone',
    KEY_CHARM: 'Porte-clés',
    OTHER_ACCESSORIES: 'Autres Accessoires',
    BESTSELLER: 'Meilleures Ventes',
    NEW: 'Nouveautés',
    SUMMER: 'Été',
    OVERSIZED: 'Oversize',
    ORGANIC: 'Bio',
    WINTER: 'Hiver',
    MAN_SWIMWEAR: 'Maillots de bain homme',
    MAN_SPORTSWEAR: 'Vêtements de sport homme',
    WOMAN_SPORTSWEAR: 'Vêtements de sport femme',
    FOOTWEAR: 'Chaussures et sandales',
    Frauen: 'Femmes',
    'Unisex / Männer': 'Unisexe / Hommes',
    Sonstiges: 'Autres articles',
    Kinder: 'Enfants & Bébés',
    'Home & Living': 'Maison & Décoration',
    Accessoires: 'Accessoires',
    Bestseller: 'Meilleures ventes',
    Neuheiten: 'Nouveautés',
    'Für den Sommer': 'Collection d’été',
    Oversized: 'Oversize',
    Organic: 'Bio',
    Winterkollektion: 'Collection d’hiver',
    Eigenmarken: 'Par MarketPrint',
    MP_ORIGINALS: 'Par MarketPrint',
};

export default categories;
